import React from 'react';
import PropTypes from 'prop-types';
import {
  Label,
  Icon,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from 'mw-style-react';
import AccessRules from '@control-front-end/common/components/AccessRules';
import UsersAvatars from '@control-front-end/common/components/UsersAvatars';
import useIntl from 'useIntl';
import mes from './intl';
import '../../CreateRefBook.scss';

function RefBookAccess({ ownerId, editMode, values, handleOnChange }) {
  const t = useIntl();

  const renderAccessList = (users) => {
    const checkIcon = <Icon type="check" size="large" />;
    return users.map(({ userId, name, avatar, privs }) => (
      <TableRow key={userId} styleName="table__row" rowSize="small">
        <TableCell styleName="table__cell user">
          <UsersAvatars size="small" users={[{ userId, name, avatar }]} />
          <Label value={name} />
          &nbsp;
          {userId === ownerId ? <Label value="(owner)" /> : null}
        </TableCell>
        <TableCell styleName="table__cell privs">
          {privs.view ? checkIcon : '-'}
        </TableCell>
        <TableCell styleName="table__cell privs">
          {privs.modify ? checkIcon : '-'}
        </TableCell>
        <TableCell styleName="table__cell privs">
          {privs.remove ? checkIcon : '-'}
        </TableCell>
      </TableRow>
    ));
  };

  const renderAccessesTable = () => {
    const users = values.access
      ? values.access.filter((u) => u.userType !== 'system')
      : [];
    const usersCount = users.length;
    const label = usersCount
      ? t(mes.bookAccessInfo, { count: usersCount })
      : t(mes.bookNotShared);
    return (
      <div styleName="row">
        <div styleName="row__label">
          <Label fontWeight="semibold" value={label} />
        </div>
        {usersCount ? (
          <Table paddingSize="small" styleName="table">
            <TableHead fixed={true}>
              <TableRow styleName="table__row" rowSize="small">
                <TableCell styleName="table__cell user">
                  {t(mes.name)}
                </TableCell>
                <TableCell styleName="table__cell privs">
                  {t(mes.view)}
                </TableCell>
                <TableCell styleName="table__cell privs">
                  {t(mes.edit)}
                </TableCell>
                <TableCell styleName="table__cell privs">
                  {t(mes.delete)}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{renderAccessList(users)}</TableBody>
          </Table>
        ) : null}
      </div>
    );
  };

  return (
    <div styleName="l.content__access">
      {editMode ? (
        <div styleName="content__access">
          <AccessRules
            styleType="embeded"
            rules={values.access}
            ownerId={ownerId}
            onChange={(access) =>
              handleOnChange({ id: 'access', value: access })
            }
          />
        </div>
      ) : (
        renderAccessesTable()
      )}
    </div>
  );
}

RefBookAccess.propTypes = {
  ownerId: PropTypes.number,
  editMode: PropTypes.bool,
  values: PropTypes.object,
  handleOnChange: PropTypes.func,
};

export default RefBookAccess;
